// @flow weak

import _ from 'lodash';

const shouldRender = ({ needs, parent, meta }) => {
  if (!needs) {
    return true;
  }

  const allValues = parent.value;

  if (_.isFunction(needs)) {
    return needs(allValues, meta);
  }

  return allValues[needs];
};

const plugin = config => {
  const { createElement_Field: origCreateElement_Field } = config;

  return {
    createElement_Field(props, children) {
      if (shouldRender(props.field)) {
        return origCreateElement_Field(props, children);
      }

      return null;
    },
  };
};

export default plugin;
